<template>
  <div>
    <div class="tw-py-2 sm:tw-py-0 sm:tw-grid sm:tw-grid-cols-4 sm:tw-gap-4" v-if="isEditing">
      <dt class="tw-text-xs sm:tw-text-sm tw-text-gray-500 tw-font-light tw-flex tw-items-center">Mailing Address</dt>
      <div class="tw-flex tw-items-center sm:tw-pt-4 sm:tw-col-span-2">
        <base-form ref="form" class="tw-w-full ">
          <base-text-field class="tw-col-span-2 tw-mt-4 sm:tw-mt-0" label="Line 1" placeholder="Enter line 1" v-model="mailingAddressLine1" required />
          <base-text-field label="Line 2" placeholder="Enter line 2" v-model="mailingAddressLine2" />
          <base-text-field label="City" placeholder="Enter city" v-model="mailingCity" required class="tw-mt-5" />
          <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-x-4">
            <base-select label="State" placeholder="Select state" :options="STATE_OPTIONS" label-key="name" v-model="mailingState" required />
            <base-text-field label="Zip Code" placeholder="Enter zip code" v-model="mailingPostalCode" required />
          </div>
        </base-form>
      </div>
      <div class="sm:tw-flex sm:tw-flex-row-reverse sm:tw-items-center">
        <base-button size="sm" @click="save" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3">Save</base-button>
        <base-button size="sm" type="flat" @click="isEditing = false" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">Cancel</base-button>
      </div>
    </div>
    <div class="tw-py-2 sm:tw-py-4 sm:tw-grid sm:tw-grid-cols-4 sm:tw-gap-4" v-else>
      <dt class="tw-text-xs sm:tw-text-sm tw-text-gray-500 tw-font-light tw-flex tw-items-center">Mailing Address</dt>
      <dd class="tw-mt-1 tw-flex tw-text-sm tw-text-gray-900 sm:tw-mt-0 sm:tw-col-span-3 tw-mb-0">
        <div v-if="user.mailingAddressLine1 || user.mailingAddressLine2 || lastAddressLine" class="tw-flex-grow">
          <div v-if="user.mailingAddressLine1">{{ user.mailingAddressLine1 }}</div>
          <div v-if="user.mailingAddressLine2">{{ user.mailingAddressLine2 }}</div>
          <div v-if="lastAddressLine">{{ lastAddressLine }}</div>
        </div>
        <div class="tw-flex-grow" v-else>-</div>
        <span class="tw-ml-4 tw-flex-shrink-0 tw-flex tw-items-center">
          <base-button type="text" @click="startEditing">Update</base-button>
        </span>
      </dd>
    </div>
  </div>
</template>

<script>
import { STATE_OPTIONS } from "@/constants/constants";

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isEditing: false,
      isLoading: false,
      STATE_OPTIONS,
      mailingAddressLine1: "",
      mailingAddressLine2: "",
      mailingCity: "",
      mailingState: "",
      mailingPostalCode: "",
    };
  },
  computed: {
    lastAddressLine() {
      let line = "";

      if (this.user.mailingCity) {
        line += this.user.mailingCity;
      }
      if (this.user.mailingState) {
        if (line) {
          line += ", ";
        }
        line += this.user.mailingState;
      }
      if (this.user.mailingPostalCode) {
        if (line) {
          line += ", ";
        }
        line += this.user.mailingPostalCode;
      }

      return line;
    },
  },
  methods: {
    startEditing() {
      this.mailingAddressLine1 = this.user.mailingAddressLine1;
      this.mailingAddressLine2 = this.user.mailingAddressLine2;
      this.mailingCity = this.user.mailingCity;
      this.mailingState = this.user.mailingState;
      this.mailingPostalCode = this.user.mailingPostalCode;

      this.isEditing = true;
    },
    async save() {
      if (!this.$refs.form.validate()) return;

      try {
        this.isLoading = true;
        const body = {
          ...this.user,
          mailingAddressLine1: this.mailingAddressLine1,
          mailingAddressLine2: this.mailingAddressLine2,
          mailingCity: this.mailingCity,
          mailingState: this.mailingState,
          mailingPostalCode: this.mailingPostalCode,
        };
        await this.$axios.put(`/users/${this.user.id}`, body);
        this.EventBus.$emit("GLOBAL_NOTIFY", { title: "User Profile Updated", message: "User info was saved successfully" });
        this.$emit("user-updated", body);
        this.isEditing = false;
      } catch (error) {
        this.EventBus.$emit("GLOBAL_ERROR", {
          title: "Issue updating profile",
          message: "We had an issue updating your profile. You may want to try again.",
          error: { message: error.response.data },
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
  watch: {
    user: {
      immediate: true,
      deep: true,
      handler() {
        this.mailingAddressLine1 = this.user.mailingAddressLine1;
        this.mailingAddressLine2 = this.user.mailingAddressLine2;
        this.mailingCity = this.user.mailingCity;
        this.mailingState = this.user.mailingState;
        this.mailingPostalCode = this.user.mailingPostalCode;
      },
    },
  },
};
</script>
